/* import __COLOCATED_TEMPLATE__ from './filter-radio-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();